import { isFunction } from '../../../../common/base';
import { findNodeByClass } from './util'; // QQ登录框

var qqFrame = {
  isReady: false,
  $frame: null,
  currentOpt: {},
  // 初始化事件等
  init: function init(callback) {
    var self = this;

    if (self.isReady) {
      isFunction(callback) && callback();
      return;
    } // tpl


    var tpl = '<div class="qqLoginCover"></div>\
			<div class="qqLoginContent">\
				<iframe class="qqLoginFrame" frameborder="0" src=""></iframe>\
			</div>';
    self.$frame = document.createElement('div');
    self.$frame.classList.add('milo-qqLogin');
    self.$frame.innerHTML = tpl;
    document.getElementsByTagName('body')[0].appendChild(self.$frame); // 绑定相关事件

    self.bindEvent();
    self.isReady = true;
    isFunction(callback) && callback();
  },
  // 绑定相关事件
  bindEvent: function bindEvent() {
    var self = this;

    window.ptlogin2_onClose = function () {
      self.close();
    }; // eslint-disable-next-line no-unused-vars


    window.ptlogin2_onResize = function (width, height) {
      /* let $loginFrame=self.$frame.find('.qqLoginContent');
      let margin_left=parseInt(0-width/2)+'px';
      let margin_top=parseInt(0-height/2)+'px';
      $loginFrame.width(width).height(height).css('marginLeft',margin_left).css('marginTop',margin_top);*/
    };

    if (typeof window.postMessage !== 'undefined') {
      window.addEventListener('message', function (event) {
        var msg = event || window.event; // 兼容IE8

        if (msg.origin == 'https://xui.ptlogin2.qq.com') {
          var data = JSON.parse(msg.data);

          switch (data.action) {
            case 'close':
              window.ptlogin2_onClose();
              break;

            case 'resize':
              {
                // 调整尺寸
                var width = data.width,
                    height = data.height;
                window.ptlogin2_onResize(width, height);
                break;
              }

            default:
              // 什么也不做，便于我们扩展接口
              break;
          }
        }
      }, false);
    }
  },
  close: function close(isForce) {
    var self = this;

    if (this.currentOpt.showParams.canClose || isForce) {
      self.$frame.style.display = 'none';
    }
  },
  show: function show(url, opt) {
    var self = this;
    self.currentOpt = opt;
    this.init(function () {
      var loginframe = findNodeByClass(self.$frame, 'qqLoginFrame');
      loginframe.setAttribute('src', url);
      /* showParams相关*/
      // zIndex

      var zIndex = Number(opt.showParams.zIndex) || 999;
      self.$frame.style.zIndex = zIndex;
      var cover = findNodeByClass(self.$frame, 'qqLoginCover');
      var content = findNodeByClass(self.$frame, 'qqLoginContent');
      cover.style.zIndex = zIndex;
      content.style.zIndex = zIndex + 1; // 是否显示cover

      if (opt.showParams.needMask) {
        cover.style.display = 'block';
      } else {
        cover.style.display = 'none';
      }

      self.$frame.style.display = 'block';
    });
  }
};
export default qqFrame;